<template>
  <div v-if="isMobileVersion" class="platforms-wrapper--mobile">
    <div v-for="platform of filteredPlatforms" :key="platform.name">
      <h1 class="platform-name--mobile">{{ platform.name }}</h1>
      <div
        v-for="[code, value] of getFilteredFields(platform)"
        :key="code"
        class="platform-field--mobile"
      >
        <div>{{ fieldsNames[code] }}</div>
        <PlatformLink
          v-if="code === 'url'"
          :value="value"
          :platform="platform"
          :feed="platform.name"
        />
        <div style="color: black" v-else>{{ value }}</div>
      </div>
    </div>
    <div>
      <div class="platform-block--mobile">Количество интересантов</div>
      <div class="platform-field--mobile" style="color: black">
        {{ interestedPartyLength }}
      </div>
    </div>
  </div>
  <table v-else class="min-wid w-full" :class="tableClass">
    <PlatformsTableHeader :platforms="platforms" />
    <PlatformsTableFields :fields="fields" :platforms="platforms" />
    <PlatformsTableInterests :interestedPartyLength="interestedPartyLength" />
  </table>
</template>

<script>
import PlatformsTableHeader from './PlatformsTableHeader.vue'
import PlatformsTableFields from './PlatformsTableFields.vue'
import PlatformsTableInterests from './PlatformsTableInterests.vue'
import PlatformLink from './PlatformLink.vue'

export default {
  name: 'PlatformsTable',
  props: {
    platformsReport: Array,
    interestedPartyLength: Number,
  },
  computed: {
    isMobileVersion() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    },
    tableClass() {
      return this.isMobileVersion ? 'platform-table-mobile' : ''
    },
    filteredPlatforms() {
      return this.platformsReport.filter((p) => {
        return Object.values(p.fields).some(Boolean)
      })
    },
  },
  methods: {
    getFilteredFields(platform) {
      return Object.entries(platform.fields).filter(([code, value]) => {
        return this.fieldsNames[code] && value
      })
    },
  },
  components: {
    PlatformsTableHeader,
    PlatformsTableFields,
    PlatformsTableInterests,
    PlatformLink,
  },
  setup(props) {
    // вычисляем название РП
    const platforms = props.platformsReport.map(
      (platform) => `${platform.name}:`,
    )

    // вычисляем поля для таблицы
    const fields = props.platformsReport.map((platform) => platform.fields)
    const fieldsNames = {
      url: 'Ссылка на объект',
      phoneShows: 'Просмотров телефона',
      totalViews: 'Всего просмотров',
      status: 'Статус',
    }
    const tableFields = {}
    Object.entries(fieldsNames).forEach(([code, name]) => {
      tableFields[code] = { name, values: [] }
    })

    fields.forEach((field) => {
      Object.entries(field).forEach(([fieldName, fieldValue]) => {
        if (!fieldsNames[fieldName]) return
        const fieldvaluesList = tableFields[fieldName].values
        fieldvaluesList.push(fieldValue)
      })
    })
    return {
      platforms,
      fields: Object.entries(tableFields),
      fieldsNames,
    }
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@500&display=swap');
.platform-table-mobile {
  margin-left: 1rem;
}
.platform-name--mobile {
  font-size: 20px;
  font-weight: 500;
  font-family: Inter;
}
.platform-field--mobile {
  font-size: 14px;
  font-weight: 400;
  font-family: Inter;
  color: #636161;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 0.6rem;
}
.platforms-wrapper--mobile {
  margin: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
